import { Suspense, lazy, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { ApolloProvider } from '@apollo/client/react';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import { ThemeProvider } from '@bluecodecom/theme';

import { nativeService } from '@bluecodecom/native';

import { apolloClient } from '@bluecodecom/digital-goods-webview/features/apollo';

import './i18n';

const App = lazy(() => import('./app'));

const Main = () => {
  useEffect(() => {
    nativeService.hideNavigation();
    nativeService.allowResumeMiniApp();
  }, []);

  return (
    <ThemeProvider observe>
      <LoaderProvider>
        <BrowserRouter>
          <Suspense>
            <ApolloProvider client={apolloClient}>
              <App />
            </ApolloProvider>
          </Suspense>
        </BrowserRouter>
      </LoaderProvider>
    </ThemeProvider>
  );
};

createRoot(document.getElementById('root') as HTMLElement).render(<Main />);
